import {updateSetting, getAllSettings} from "../api";
import AppState from '../state/AppState';
import Toaster from "../components/Toaster";
import { Intent } from "@blueprintjs/core";

export const setUserSetting = (setting, value, successToast, userId) => {
  return updateSetting("user", userId || AppState.state.user.id, setting, value)
    .then(() => getAllSettings("user", userId || AppState.state.user.id))
    .then((result) => {
      AppState.setUserSettings(result.settings);
      if (successToast) {
        Toaster.show({ message: "Successfully set as default.",  iconName: "tick", intent: Intent.SUCCESS });
      }
    })
    .catch((e) => {
      Toaster.show({ message: e.message, iconName: "warning-sign",  intent: Intent.DANGER });
    });
};




// WEBPACK FOOTER //
// ./src/actions/SettingsActions.js